import { ReportData } from '../types/reportTypes';

// September 2025 Sales Data - Standard Report (32 jobs from CSV)
const jobData = [
  {
    jobInfo: "Mariel Galvan",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 12276.00,
    grossMarginPct: 0.4311,
    grossProfit: 5292.18,
    commissionPercentage: 4.00,
    salesCommission: 491.04,
    salesManagerFee: 122.76,
    companyOH: 1902.78,
    netProfit: 0
  },
  {
    jobInfo: "Carolyn Councell",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 8619.00,
    grossMarginPct: 0.5563,
    grossProfit: 4794.75,
    commissionPercentage: 7.00,
    salesCommission: 603.33,
    salesManagerFee: 86.19,
    companyOH: 1335.95,
    netProfit: 0
  },
  {
    jobInfo: "Zach & PAIGE Baron",
    leadSource: "Facebook / Meta Ads",
    trade: "Windows & Doors",
    contractTotal: 3450.00,
    grossMarginPct: 0.4629,
    grossProfit: 1597.01,
    commissionPercentage: 4.00,
    salesCommission: 138.00,
    salesManagerFee: 34.50,
    companyOH: 534.75,
    netProfit: 0
  },
  {
    jobInfo: "Aragie & elini Kahnie",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 19972.00,
    grossMarginPct: 0.4693,
    grossProfit: 9372.86,
    commissionPercentage: 4.00,
    salesCommission: 798.88,
    salesManagerFee: 199.72,
    companyOH: 3095.66,
    netProfit: 0
  },
  {
    jobInfo: "Michael & Ann Theisen",
    leadSource: "Homebuddy",
    trade: "Roofing",
    contractTotal: 25467.00,
    grossMarginPct: 0.6192,
    grossProfit: 15769.17,
    commissionPercentage: 10.00,
    salesCommission: 2546.70,
    salesManagerFee: 254.67,
    companyOH: 3947.39,
    netProfit: 0
  },
  {
    jobInfo: "Cynthia & Roger Zuniga",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 42621.00,
    grossMarginPct: 0.4889,
    grossProfit: 20837.41,
    commissionPercentage: 4.00,
    salesCommission: 1704.84,
    salesManagerFee: 426.21,
    companyOH: 6606.26,
    netProfit: 0
  },
  {
    jobInfo: "DuJuan Daniels",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 7221.00,
    grossMarginPct: 0.6271,
    grossProfit: 4528.29,
    commissionPercentage: 10.00,
    salesCommission: 722.10,
    salesManagerFee: 72.21,
    companyOH: 1119.26,
    netProfit: 0
  },
  {
    jobInfo: "Eric Weinstein",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 25621.00,
    grossMarginPct: 0.4898,
    grossProfit: 12549.17,
    commissionPercentage: 4.00,
    salesCommission: 1024.84,
    salesManagerFee: 256.21,
    companyOH: 3971.26,
    netProfit: 0
  },
  {
    jobInfo: "John Streibich",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 14221.00,
    grossMarginPct: 0.4005,
    grossProfit: 5695.51,
    commissionPercentage: 4.00,
    salesCommission: 568.84,
    salesManagerFee: 142.21,
    companyOH: 2204.26,
    netProfit: 0
  },
  {
    jobInfo: "Jay & Liza Fagan",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 8271.00,
    grossMarginPct: 0.4002,
    grossProfit: 3310.05,
    commissionPercentage: 4.00,
    salesCommission: 330.84,
    salesManagerFee: 82.71,
    companyOH: 1282.01,
    netProfit: 0
  },
  {
    jobInfo: "Lynda & Rajiv Torres Ganesann",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 40517.00,
    grossMarginPct: 0.4000,
    grossProfit: 16206.80,
    commissionPercentage: 4.00,
    salesCommission: 1620.68,
    salesManagerFee: 405.17,
    companyOH: 6280.14,
    netProfit: 0
  },
  {
    jobInfo: "Alan & Sharon Horowitz",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 6472.00,
    grossMarginPct: 0.2240,
    grossProfit: 1449.73,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 64.72,
    companyOH: 1003.16,
    netProfit: 0
  },
  {
    jobInfo: "E-632: Beth Yu",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 3621.00,
    grossMarginPct: 0.6493,
    grossProfit: 2351.12,
    commissionPercentage: 10.00,
    salesCommission: 362.10,
    salesManagerFee: 36.21,
    companyOH: 561.26,
    netProfit: 0
  },
  {
    jobInfo: "E-612: Will Thomas",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 6221.00,
    grossMarginPct: 0.6929,
    grossProfit: 4310.53,
    commissionPercentage: 10.00,
    salesCommission: 622.10,
    salesManagerFee: 62.21,
    companyOH: 964.26,
    netProfit: 0
  },
  {
    jobInfo: "E-621: Silvano CALDERA",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 15552.00,
    grossMarginPct: 0.5137,
    grossProfit: 7989.06,
    commissionPercentage: 7.00,
    salesCommission: 1088.64,
    salesManagerFee: 155.52,
    companyOH: 2410.56,
    netProfit: 0
  },
  {
    jobInfo: "E-606: Richard & Janice Webster",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 2893.00,
    grossMarginPct: 0.6028,
    grossProfit: 1743.90,
    commissionPercentage: 10.00,
    salesCommission: 289.30,
    salesManagerFee: 28.93,
    companyOH: 448.42,
    netProfit: 0
  },
  {
    jobInfo: "E-604: Donald Smedley",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 32724.00,
    grossMarginPct: 0.4180,
    grossProfit: 13678.63,
    commissionPercentage: 4.00,
    salesCommission: 1308.96,
    salesManagerFee: 327.24,
    companyOH: 5072.22,
    netProfit: 0
  },
  {
    jobInfo: "E-630: Ben & Jenifer Garner",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 19872.00,
    grossMarginPct: 0.4474,
    grossProfit: 8890.73,
    commissionPercentage: 4.00,
    salesCommission: 794.88,
    salesManagerFee: 198.72,
    companyOH: 3080.16,
    netProfit: 0
  },
  {
    jobInfo: "E-610: Alison Canning",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 1972.00,
    grossMarginPct: 0.4283,
    grossProfit: 844.61,
    commissionPercentage: 4.00,
    salesCommission: 78.88,
    salesManagerFee: 19.72,
    companyOH: 305.66,
    netProfit: 0
  },
  {
    jobInfo: "E-623: Julie Zuckerbrod",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 2492.00,
    grossMarginPct: 0.5303,
    grossProfit: 1321.51,
    commissionPercentage: 7.00,
    salesCommission: 174.44,
    salesManagerFee: 24.92,
    companyOH: 386.26,
    netProfit: 0
  },
  {
    jobInfo: "E-620: Mark & Gina Tew",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 20779.00,
    grossMarginPct: 0.4110,
    grossProfit: 8540.17,
    commissionPercentage: 4.00,
    salesCommission: 831.16,
    salesManagerFee: 207.79,
    companyOH: 3220.75,
    netProfit: 0
  },
  {
    jobInfo: "E-618: Jen Looper",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 4513.00,
    grossMarginPct: 0.5127,
    grossProfit: 2313.82,
    commissionPercentage: 7.00,
    salesCommission: 315.91,
    salesManagerFee: 45.13,
    companyOH: 699.52,
    netProfit: 0
  },
  {
    jobInfo: "E-601: Amanda & Edward Bellows",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 3221.00,
    grossMarginPct: 0.5733,
    grossProfit: 1846.60,
    commissionPercentage: 7.00,
    salesCommission: 225.47,
    salesManagerFee: 32.21,
    companyOH: 499.26,
    netProfit: 0
  },
  {
    jobInfo: "E-605: Sarah & Rebecca Weeks",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 16116.00,
    grossMarginPct: 0.5088,
    grossProfit: 8199.82,
    commissionPercentage: 7.00,
    salesCommission: 1128.12,
    salesManagerFee: 161.16,
    companyOH: 2497.98,
    netProfit: 0
  },
  {
    jobInfo: "Rob & Diane Huyett",
    leadSource: "Networx",
    trade: "Insulation",
    contractTotal: 2100.00,
    grossMarginPct: 0.4612,
    grossProfit: 968.52,
    commissionPercentage: 4.00,
    salesCommission: 84.00,
    salesManagerFee: 21.00,
    companyOH: 325.50,
    netProfit: 0
  },
  {
    jobInfo: "Lynne & Barrington Taylor",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 7992.00,
    grossMarginPct: 0.4000,
    grossProfit: 3196.80,
    commissionPercentage: 4.00,
    salesCommission: 319.68,
    salesManagerFee: 79.92,
    companyOH: 1238.76,
    netProfit: 0
  },
  {
    jobInfo: "Christian & joise Pleasant",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 5272.00,
    grossMarginPct: 0.4000,
    grossProfit: 2108.80,
    commissionPercentage: 4.00,
    salesCommission: 210.88,
    salesManagerFee: 52.72,
    companyOH: 817.16,
    netProfit: 0
  },
  {
    jobInfo: "E-593: Tom & Laura Bailey",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 4000.00,
    grossMarginPct: 0.4434,
    grossProfit: 1773.60,
    commissionPercentage: 4.00,
    salesCommission: 160.00,
    salesManagerFee: 40.00,
    companyOH: 620.00,
    netProfit: 0
  },
  {
    jobInfo: "E-609: Dhammika DeSilva",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 2700.00,
    grossMarginPct: 0.4652,
    grossProfit: 1256.04,
    commissionPercentage: 4.00,
    salesCommission: 108.00,
    salesManagerFee: 27.00,
    companyOH: 418.50,
    netProfit: 0
  },
  {
    jobInfo: "E-596: Liat& SHeldon Novek",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 18963.50,
    grossMarginPct: 0.4883,
    grossProfit: 9259.88,
    commissionPercentage: 4.00,
    salesCommission: 758.54,
    salesManagerFee: 189.64,
    companyOH: 2939.34,
    netProfit: 0
  },
  {
    jobInfo: "E-599: Steven Solomon",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 872.00,
    grossMarginPct: 0.4249,
    grossProfit: 370.51,
    commissionPercentage: 4.00,
    salesCommission: 34.88,
    salesManagerFee: 8.72,
    companyOH: 135.16,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from CSV
const adSpendData = [
  { source: "Networx", spend: 2198.00 },
  { source: "Thumbtack", spend: 15300.00 },
  { source: "Yelp", spend: 9212.00 },
  { source: "Porch", spend: 254.80 },
  { source: "Web to Lead Form", spend: 10480.00 },
  { source: "Angi", spend: 2530.00 },
  { source: "Homebuddy", spend: 2865.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Google Paid Search", spend: 4656.90 },
  { source: "Facebook / Meta Ads", spend: 4312.44 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Suburban MD Spring Home Show- Upper Marlboro 2025", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const septemberData: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 9, // September
    year: 2025
  }
};
